import * as React from "react";
import { StatusBar } from "expo-status-bar";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { QueryClient, QueryClientProvider } from "react-query";

import useCachedResources from "./hooks/useCachedResources";
import useColorScheme from "./hooks/useColorScheme";
import Navigation from "./navigation/Navigation";
import Auth from "./auth";
import useStore from "./store/useStore";
import { StoreProvider } from "easy-peasy";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 200,
    },
  },
});

function App() {
  const { promise: storePromise, data: store } = useStore();
  const { isLoading } = useCachedResources({ storePromise });
  const colorScheme = useColorScheme();

  if (isLoading || !store) {
    return null;
  }

  return (
    <StoreProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <SafeAreaProvider>
          <Auth.Provider>
            <Auth.ServicesProvider>
              <Auth.Authorized>
                <Navigation colorScheme={colorScheme} />

                <StatusBar />
              </Auth.Authorized>
            </Auth.ServicesProvider>
          </Auth.Provider>
        </SafeAreaProvider>
      </QueryClientProvider>
    </StoreProvider>
  );
}

export default App;
